// extracted by mini-css-extract-plugin
module.exports = {"guidedContent":"GuidedContent-module--guidedContent--2uDYL","curatedItem":"GuidedContent-module--curatedItem--1UdRU","text":"GuidedContent-module--text--3n_kQ"};